import Vue from 'vue'
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import App from './App'
import router from './router'
import store from './store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFrown } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

var Rollbar = require('vue-rollbar');

Vue.config.productionTip = false

// rollbar
Vue.use(Rollbar, {
  accessToken: '743045684d5644a698d410ed9d07e280’',
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: true,
  source_map_enabled: true,
  environment: 'production',
  payload: {
    client: {
         javascript: {
            code_version: '1.0'
         }
    }
  }
});

// vuetify
Vue.use(Vuetify);

// font awesome
Vue.component('font-awesome-icon', FontAwesomeIcon);
library.add(faFrown)



new Vue({
  vuetify: new Vuetify(),
  router,
  store,
  render: h => h(App)
}).$mount('#app')
